<div class="navbar bg-base-100 p-8 justify-center" [ngClass]="{ 'bg-transparent absolute': isTransparent }">
    <div class="navbar-start">
        <div class="dropdown" (click)="hideHamburgerMenu = !hideHamburgerMenu">
            <div tabindex="0" role="button" class="btn btn-ghost lg:hidden">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" />
                </svg>
            </div>
            <ul
                tabindex="0"
                class="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52"
                *ngIf="hideHamburgerMenu"
            >
                @if (isLandingPage) {
                <ng-container *ngTemplateOutlet="menuLinks"></ng-container>
                }
            </ul>
        </div>
        <a class="text-xl lg:ms-24" routerLink="/">
            @if (isTransparent) {<img src="logo.webp" class="logo-img" />} @else {<img src="opaque-logo.webp" class="logo-img" />}
        </a>
    </div>
    <div class="navbar-center hidden lg:flex">
        <ul class="menu menu-horizontal px-1 text-base" [ngClass]="{ 'text-white': isTransparent }">
            @if (isLandingPage) {
            <ng-container *ngTemplateOutlet="menuLinks"></ng-container>
            }
        </ul>
    </div>
    <div class="navbar-end">
        <a
            *ngIf="!isAdminPanel"
            class="btn book-now-btn lg:me-24 bg-transparent"
            href="tel:+918972384814"
            [ngClass]="{ 'text-white': isTransparent }"
            >+91 89723 84814</a
        >
        <div *ngIf="isAdminPanel">
            @if (isLoggedIn === false) {
            <a routerLink="/login" class="btn book-now-btn lg:me-24 bg-transparent">Log In</a>
            <a routerLink="/register" *ngIf="environment !== 'production'" class="btn book-now-btn lg:me-24 bg-transparent">Register</a>
            } @else if(isLoggedIn === true) {
            <a (click)="logout()" class="btn book-now-btn lg:me-24 bg-transparent">Log Out</a>
            }
        </div>
    </div>
</div>

<ng-template #menuLinks>
    <li><a routerLink="/">Home</a></li>
    <li><a routerLink="/rooms">Rooms</a></li>
    <li><a routerLink="/contact">Contact</a></li>
</ng-template>
